
const SessionTimesHero = () => {
  return (
    <section 
      className="relative h-96 bg-cover bg-center flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/51302b3608e92d018515ddb9c0ef28f7.jpg')`
      }}
    >
      <div className="text-center text-white max-w-4xl mx-auto px-6">
        <h1 className="text-5xl font-bold mb-6 drop-shadow-lg">
          Training Session Times
        </h1>
        <p className="text-xl leading-relaxed">
          Find the perfect training schedule for your young athlete. Our flexible session times accommodate busy family schedules while ensuring consistent skill development.
        </p>
      </div>
    </section>
  );
};

export default SessionTimesHero;
